// extracted by mini-css-extract-plugin
export default {"wrapper":"s34CF","footnote":"TT_vf"};